<template>
    <div id="citizenTab" class="">
        <div class="actions text-end mb-2">
            <button class="mt-2 me-2 btn btn-primary" @click.prevent="handleAddCitizen()">Add a Citizen</button>
        </div>
        <div class="row px-3 py-2" v-for="(citizen, citizenIndex) in contactFullReport!.citizens" :key="keyColumn">
            <div class="col-12 border-rounded-gray" v-if="contactFullReport!.citizens != undefined">
                <div class="ucheader">
                    <div class="left">
                        <span class="Title">Citizen {{ citizenIndex + 1 }}</span>
                    </div>
                    <div class="right">
                        <button class="btn btn-link confirm-remove"
                            @click.prevent="handleRemoveForCitizen(citizenIndex)">Remove</button>
                    </div>
                </div>
                <div class="">
                    <div class="validationSideBySideDiv">
                        <div class="left">
                            <label style="font-weight:bold;">Age <span class="requiredfieldasterisk">*</span></label>
                        </div>
                        <div class="right">
                            <span style="color:Red;visibility:hidden;">Required</span>
                        </div>
                    </div>
                    <age-exact-range-radio-buttons :index="citizenIndex" v-model="citizen.perceived_information.age"
                        :is-horizontal="true" :is-disabled="false" :is-required="true" :ref="(el) => { addValidatableComponent(el) }"></age-exact-range-radio-buttons>
                </div>
                <div class="row mb-3">
                    <div class="col-12">
                        <div class="inputWrapper">
                            <div class="validationSideBySideDiv">
                                <div class="left">
                                    <label style="font-weight:bold;">Gender <span
                                            class="requiredfieldasterisk">*</span></label>
                                </div>
                                <div class="right">
                                    <span style="color:Red;visibility:hidden;">Required</span>
                                </div>
                            </div>

                            <SelectField v-model="citizen.perceived_information.gender"
                                :select-items="contactsStore.getGender" :is-horizontal="false" :is-required="true" :ref="(el) => { addValidatableComponent(el) }">
                            </SelectField>
                        </div>
                        <div class="inputWrapper">
                            <div class="validationSideBySideDiv">
                                <div class="left">
                                    <label style="font-weight:bold;">Race <span
                                            class="requiredfieldasterisk">*</span></label>
                                </div>
                                <div class="right">
                                    <span style="color:Red;visibility:hidden;">Required</span>
                                </div>
                            </div>

                            <SelectField v-model="citizen.perceived_information.race" :select-items="contactsStore.getRace"
                                :is-horizontal="false" :is-required="true" :ref="(el) => { addValidatableComponent(el) }">
                            </SelectField>

                        </div>
                        <div class="inputWrapper">
                            <div class="validationSideBySideDiv">
                                <div class="left">
                                    <label style="font-weight:bold;">Ethnicity <span
                                            class="requiredfieldasterisk">*</span></label>
                                </div>
                                <div class="right">
                                    <span style="color:Red;visibility:hidden;">Required</span>
                                </div>
                            </div>

                            <SelectField v-model="citizen.perceived_information.ethnicity"
                                :select-items="contactsStore.getEthnicity" :is-horizontal="false" :is-required="true" :ref="(el) => { addValidatableComponent(el) }">
                            </SelectField>

                        </div>
                        <div class="inputWrapper">
                            <div class="validationSideBySideDiv">
                                <div class="left">
                                    <label style="font-weight:bold;">Contact Reason <span
                                            class="requiredfieldasterisk">*</span></label>
                                </div>
                                <div class="right">
                                    <span style="color:Red;visibility:hidden;">Required</span>
                                </div>
                            </div>

                            <SelectField v-model="citizen.contact_reason" :select-items="contactsStore.getContactReason"
                                :is-horizontal="false" :is-required="true" :ref="(el) => { addValidatableComponent(el) }">
                            </SelectField>

                        </div>
                        <div class="inputWrapper align-bottom">
                            <div class="validationSideBySideDiv">
                                <div class="left">
                                    <label style="font-weight:bold;">Suspected Offenses</label>
                                </div>
                                <div class="right">

                                </div>
                            </div>

                            <SelectField v-model="citizen.suspected_offenses"
                                :select-items="contactsStore.getCrimeCategorySuspected" :mode="'tags'" :is-required="false" :ref="(el) => { addValidatableComponent(el) }">
                            </SelectField>
                        </div>
                        <div class="inputWrapper align-bottom">
                            <div class="validationSideBySideDiv">
                                <div class="left">
                                    <label style="font-weight:bold;">Information Collected</label>
                                </div>
                                <div class="right">

                                </div>
                            </div>
                            <SelectField v-model="citizen.information_collected"
                                :select-items="contactsStore.getInformationCollected" :mode="'tags'" :is-required="false" :ref="(el) => { addValidatableComponent(el) }">
                            </SelectField>
                        </div>
                    </div>
                </div>
                <div class=" mb-3">
                    <div class="card">
                        <div class="card-header">
                            Offense Information
                        </div>
                        <div class="card-body">
                            <div class="inputWrapper align-top">
                                <div class="validationSideBySideDiv">
                                    <div class="left">
                                        <label style="font-weight:bold;">Action Taken <span
                                                class="requiredfieldasterisk">*</span></label>
                                    </div>
                                    <div class="right">
                                        <span style="color:Red;visibility:hidden;">Required</span>
                                    </div>
                                </div>
                                <SelectField v-model="citizen.action_taken"
                                    :select-items="contactsStore.getContactOutcome" :mode="'tags'"
                                    :is-required="true" :is-action-taken="true" :ref="(el) => { addValidatableComponent(el) }"></SelectField>
                            </div>
                            <div class="inputWrapper align-top">
                                <div class="validationSideBySideDiv">
                                    <div class="left">
                                        <label style="font-weight:bold;">Arrest Offenses</label>
                                    </div>
                                    <div class="right">

                                    </div>
                                </div>

                                <SelectField v-model="citizen.arrest_offenses"
                                    :select-items="contactsStore.getCrimeCategoryCommitted" :mode="'tags'"
                                    :is-required="false" :ref="(el) => { addValidatableComponent(el) }"></SelectField>
                            </div>
                            <div class="inputWrapper align-top">
                                <div class="validationSideBySideDiv">
                                    <div class="left">
                                        <label style="font-weight:bold;">Citation Offenses</label>
                                    </div>
                                    <div class="right">

                                    </div>
                                </div>

                                <SelectField v-model="citizen.citation_offenses"
                                    :select-items="contactsStore.getCrimeCategoryCommitted" :mode="'tags'"
                                    :is-required="false" :ref="(el) => { addValidatableComponent(el) }"></SelectField>
                            </div>
                            <div class="inputWrapper align-top">
                                <div class="validationSideBySideDiv">
                                    <div class="left">
                                        <label style="font-weight:bold;">Warning Offenses</label>
                                    </div>
                                    <div class="right">

                                    </div>
                                </div>
                                <SelectField v-model="citizen.warning_offenses"
                                    :select-items="contactsStore.getCrimeCategorySuspected" :mode="'tags'"
                                    :is-required="false" :ref="(el) => { addValidatableComponent(el) }"></SelectField>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="vstack gap-3 mb-3">
                    <button class="mb-3 d-block btn btn-outline-secondary maxwidth375"
                        @click.prevent="addUOFDetails(citizen)" v-if="citizen.use_of_force_details == null">Add Use of Force
                        Details</button>
                    <div class="card" v-if="citizen.use_of_force_details != null">
                        <div class="card-header">
                            <div class="row">
                                <div class="col-6 text-start">
                                    Force Used on Citizen
                                </div>
                                <div class="col-6 text-end">
                                    <button class="btn-close me-3" aria-label="Remove"
                                        @click.prevent="handleRemoveUOFDetails(citizen)"></button>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="inputWrapper">
                                <div class="validationSideBySideDiv">
                                    <div class="left">
                                        <label style="font-weight:bold;">Injury Severity</label>
                                    </div>
                                    <div class="right">

                                    </div>
                                </div>
                                <SelectField v-model="citizen.use_of_force_details.injury"
                                    :select-items="contactsStore.getInjurySeverity" :is-horizontal="false"
                                    :is-required="false" :ref="(el) => { addValidatableComponent(el) }">
                                </SelectField>
                            </div>
                            <div class="inputWrapper">
                                <div class="validationSideBySideDiv">
                                    <div class="left">
                                        <label style="font-weight:bold;">Ambulance Called</label>
                                    </div>
                                    <div class="right">

                                    </div>
                                </div>
                                <SelectField v-model="citizen.use_of_force_details.ambulance_called"
                                    :select-items="contactsStore.getYesNoUnknown" :is-horizontal="false"
                                    :is-required="false" :ref="(el) => { addValidatableComponent(el) }">
                                </SelectField>
                            </div>
                            <div class="inputWrapper">
                                <div class="validationSideBySideDiv">
                                    <div class="left">
                                        <label style="font-weight:bold;">Citizen Transported</label>
                                    </div>
                                    <div class="right">

                                    </div>
                                </div>

                                <SelectField v-model="citizen.use_of_force_details.transported"
                                    :select-items="contactsStore.getYesNoUnknown" :is-horizontal="false"
                                    :is-required="false" :ref="(el) => { addValidatableComponent(el) }">
                                </SelectField>
                            </div>
                            <div class="my-3 container-fluid">
                                <h4>Weapons Shown</h4>
                                <div class="row border bg-light d-flex align-items-center" style="height:56px">
                                    <div class="col-5 h-100 d-flex align-items-center">Weapon Type</div>
                                    <div class="col-5 h-100 d-flex align-items-center border-start">Shown Before Force Used
                                        on Citizen</div>
                                    <div class="col-2 h-100 d-flex align-items-center border-start"><button
                                            class="btn btn-primary"
                                            @click.prevent="addWeaponsShown(citizen.use_of_force_details!)">Add</button>
                                    </div>
                                </div>
                                <div class="row border d-flex align-items-center"
                                    v-for="(currentExhibitedWeapon, index) in citizen.use_of_force_details?.weapons_exhibited" :key="keyColumn">
                                    <div :class="{ 'bg-light': isAlternatingRow(index) }" class="col-5 p-2">
                                        <SelectField v-model="currentExhibitedWeapon.exhibited_weapon"
                                            :select-items="contactsStore.getSubjectWeaponType" :is-horizontal="false"
                                            :is-required="true" :ref="(el) => { addValidatableComponent(el) }">
                                        </SelectField>
                                    </div>
                                    <div :class="{ 'bg-light': isAlternatingRow(index) }" class="col-5 p-2">
                                        <SelectField v-model="currentExhibitedWeapon.before_uof"
                                            :select-items="contactsStore.getYesNoUnknown" :is-horizontal="false"
                                            :is-required="true" :ref="(el) => { addValidatableComponent(el) }">
                                        </SelectField>
                                    </div>
                                    <div :class="{ 'bg-light': isAlternatingRow(index) }" class="col-2 p-2 text-end">
                                        <button class="btn-close me-3" aria-label="Remove"
                                            @click.prevent="handleRemove(citizen.use_of_force_details?.weapons_exhibited, index)"></button>
                                    </div>
                                </div>
                                <div class="row border"
                                    v-if="citizen.use_of_force_details == undefined || citizen.use_of_force_details.weapons_exhibited == undefined">
                                    <div class="col-12">
                                        No data to display
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="vstack gap-3 mb-3">
                    <button class="mb-3 d-block btn btn-outline-secondary maxwidth375"
                        @click.prevent="addShowupInfo(citizen)" v-if="citizen.showup_details == null">Add Show-up
                        Information</button>
                    <div class="card" v-if="citizen.showup_details != null">
                        <div class="card-header">
                            <div class="row">
                                <div class="col-6 my-auto">
                                    Show-up Information
                                </div>
                                <div class="col-6 text-end">
                                    <button class="btn-close me-3" aria-label="Remove"
                                        @click.prevent="handleRemoveShowUpInformation(citizen)"></button>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row border bg-light" style="height: 56px;">
                                <div class="p-2 h-100 d-flex align-items-center col">Age of Witness</div>
                                <div class="p-2 h-100 d-flex align-items-center col border-start">Gender of Witness</div>
                                <div class="p-2 h-100 d-flex align-items-center col border-start">Race of Witness</div>
                                <div class="p-2 h-100 d-flex align-items-center col border-start">Ethnicity of Witness</div>
                                <div class="p-2 h-100 d-flex align-items-center col border-start">Outcome of Show-up</div>
                                <div class="p-2 h-100 d-flex align-items-center col-2 border-start"><button
                                        class="btn btn-primary" @click.prevent="addShowupInfo(citizen)">Add</button></div>
                            </div>
                            <div class="row border d-flex align-items-center"
                                v-for="(data, index) in citizen.showup_details" :key="keyColumn">
                                <div :class="{ 'bg-light': isAlternatingRow(index) }" class="col p-2 text-center">
                                    <age-select-with-range v-model="citizen.showup_details[index].witness_information.age"
                                        :is-horizontal="false" :is-required="true"> </age-select-with-range>
                                </div>
                                <div :class="{ 'bg-light': isAlternatingRow(index) }"
                                    class="col p-2 border-start text-center">
                                    <SelectField v-model="citizen.showup_details[index].witness_information.gender"
                                        :select-items="contactsStore.getGender" :is-horizontal="false" :is-required="true" :ref="(el) => { addValidatableComponent(el) }">
                                    </SelectField>
                                </div>
                                <div :class="{ 'bg-light': isAlternatingRow(index) }"
                                    class="col p-2 border-start text-center">
                                    <SelectField v-model="citizen.showup_details[index].witness_information.race"
                                        :select-items="contactsStore.getRace" :is-horizontal="false" :is-required="true" :ref="(el) => { addValidatableComponent(el) }">
                                    </SelectField>
                                </div>
                                <div :class="{ 'bg-light': isAlternatingRow(index) }"
                                    class="col p-2 border-start text-center">
                                    <SelectField v-model="citizen.showup_details[index].witness_information.ethnicity"
                                        :select-items="contactsStore.getEthnicity" :is-horizontal="false"
                                        :is-required="true" :ref="(el) => { addValidatableComponent(el) }">
                                    </SelectField>
                                </div>
                                <div :class="{ 'bg-light': isAlternatingRow(index) }"
                                    class="col p-2 border-start text-center">
                                    <SelectField v-model="citizen.showup_details[index].showup_outcome"
                                        :select-items="contactsStore.getShowUpIdOutcome" :is-horizontal="false"
                                        :is-required="true" :ref="(el) => { addValidatableComponent(el) }">
                                    </SelectField>
                                </div>
                                <div :class="{ 'bg-light': isAlternatingRow(index) }"
                                    class="col-2 p-2 border-start mt-1 text-end">
                                    <button class="btn-close me-3" aria-label="Remove"
                                        @click.prevent="handleRemove(citizen.showup_details, index)"></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-for="(searchDetailsData, searchDetailsIndex) in contactsStore.getWhatSearched" :key="keyColumn">
                    <search-container :index="citizenIndex" :search-details-data="searchDetailsData"
                        :search-details-index="searchDetailsIndex" :ref="(el) => { addValidatableComponent(el) }"></search-container>
                </div>
            </div>
        </div>
        <div class="actions text-end mt-2"
            v-show="contactsStore.contactFullReport!.citizens && contactsStore.contactFullReport!.citizens.length > 0">
            <button class="btn btn-primary mb-2 me-2" @click.prevent="handleAddCitizen()">Add a Citizen</button>
        </div>
    </div>
</template>
<script lang="ts">
import { defineComponent, defineExpose, ref } from 'vue';
import { useContactsStore } from '../../stores/contactsStore';
import { storeToRefs } from 'pinia';
import SelectField from '../Misc/SelectField.vue';
import AgeExactRangeRadioButtons from '../Misc/AgeExactRangeRadioButtons.vue';
import AgeSelectWithRange from '../Misc/AgeSelectWithRange.vue';
import SearchContainer from './SearchContainer.vue';
import { Citizen, SubjectWeaponType, WeaponShown, YesNoUnknown, PerceivedInfo, CitizenUOFDetails } from './schema';
import useValidation from '../Misc/validationUtils';

export default defineComponent({
    name: 'citizen',
    components: {
        SelectField,
        AgeExactRangeRadioButtons,
        AgeSelectWithRange,
        SearchContainer
    },
    setup() {        
        const keyColumn = 'generated_id';
        const contactsStore = useContactsStore();
        var { contactFullReport } = storeToRefs(useContactsStore());        
        contactsStore.fetchAges();

        const {validatableComponentArray, triggerValidation, addValidatableComponent, resetValidatableComponentArray } = useValidation();

        return { contactsStore, contactFullReport, keyColumn, triggerValidation, validatableComponentArray, addValidatableComponent, resetValidatableComponentArray };
    },
    methods: {
        isAlternatingRow(index: number): boolean {
            return index % 2 == 1;
        },
        addShowupInfo(citizen: Citizen) {
            if (citizen.showup_details == null) {
                citizen.showup_details = [];
            }

            citizen.showup_details.push({
                showup_outcome: "",
                witness_information: {
                    age: "",
                    ethnicity: "",
                    gender: "",
                    race: ""
                }
            });
        },
        addWeaponsShown(uofDetails: CitizenUOFDetails) {

            if (uofDetails.weapons_exhibited == undefined) {
                uofDetails.weapons_exhibited = [] as WeaponShown[];
            }

            let newItem = {
                before_uof: "" as YesNoUnknown,
                exhibited_weapon: "" as SubjectWeaponType
            } as WeaponShown;

            uofDetails.weapons_exhibited.push(newItem);
        },
        addUOFDetails(citizen: Citizen) {

            if (citizen.use_of_force_details == null) {
                citizen.use_of_force_details = {
                    ambulance_called: undefined,
                    injury: undefined,
                    transported: undefined,
                    weapons_exhibited: []
                } as CitizenUOFDetails;
            }

        },
        handleInputChange(info: { event; any, field: any }) {
            info.field = [];

            if (info.event && info.event.length) {
                info.event.forEach(element => {
                    info.field.push(element.value);
                });
            }
        },
        handleRemove(array: any, index: number) {
            this.resetValidatableComponentArray();
            array.splice(index, index >= 0 ? 1 : 0);
        },
        handleRemoveForCitizen(citizenIndex: number) {
            this.resetValidatableComponentArray();

            if (this.contactFullReport!.officers != undefined) {
                //remove reference to citizen from Officers -> Use of Force -> Citizen(s) Force Directed at
                for (let officerIndex = 0; officerIndex < this.contactFullReport!.officers.length; officerIndex++) {

                    if (this.contactFullReport!.officers[officerIndex].force_details != undefined) {

                        for (let forceDetailsIndex = 0; forceDetailsIndex < this.contactFullReport!.officers[officerIndex].force_details!.length; forceDetailsIndex++) {

                            if (this.contactFullReport!.officers[officerIndex].force_details![forceDetailsIndex].directed_at) {

                                let targetIndex = this.contactFullReport!.officers[officerIndex].force_details![forceDetailsIndex].directed_at.findIndex((f) => f === citizenIndex);

                                this.handleRemove(this.contactFullReport!.officers[officerIndex].force_details![forceDetailsIndex].directed_at, targetIndex);
                            }
                        }
                    }

                }
            }

            //remove actual citizen
            this.contactsStore.contactFullReport!.citizens!.splice(citizenIndex, 1);

        },
        handleAddCitizen() {
            if (this.contactsStore.contactFullReport!.citizens == undefined) {
                this.contactsStore.$patch((state) => {
                    state.contactFullReport!.citizens = [] as Citizen[]
                });
            }

            this.contactsStore.$patch((state) => {
                state.contactFullReport!.citizens!.push({
                    perceived_information: {
                        age: "",
                        gender: "",
                        race: "",
                        ethnicity: ""
                    } as PerceivedInfo,
                    contact_reason: "",
                    action_taken: undefined,
                    warning_offenses: undefined,
                    search_details: undefined,
                    information_collected: undefined,
                    citation_offenses: undefined,
                    arrest_offenses: undefined,
                    use_of_force_details: undefined,
                    showup_details: undefined,
                    suspected_offenses: undefined
                } as Citizen)
            });

            var body = document.body,
                html = document.documentElement;

            var height = Math.max(body.scrollHeight, body.offsetHeight,
                html.clientHeight, html.scrollHeight, html.offsetHeight);

            window.scrollTo({
                top: height,
                left: 0,
                behavior: 'smooth'
            });
        },
        handleRemoveUOFDetails(citizen: Citizen) {
            this.resetValidatableComponentArray();
            if (citizen) {
                citizen.use_of_force_details = undefined;
            }
        },
        handleRemoveShowUpInformation(citizen: Citizen) {
            this.resetValidatableComponentArray();
            if (citizen) {
                citizen.showup_details = undefined;
            }
        },
    }
});
</script>